import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductSubTypeRequestModel, IProductSubTypeResponseModel } from '../models/models'

export class ProductSubTypeDetailListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/product/ProductSubTypeDetailList',
      requesterInfo,
    })
  }

  public async ProductSubTypeDetailList(req: IProductSubTypeRequestModel): Promise<IProductSubTypeResponseModel[]> {
    return await this.postAsync<IProductSubTypeResponseModel[]>(req)
  }
}
